import { withStyles } from '@material-ui/core';
import AddForm from './AddForm';
import styles from './styles';


export default withStyles(styles)(AddForm);
